/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ArtifactsControllerFindAllQueryResponse, ArtifactsControllerFindAllPathParams, ArtifactsControllerFindAllQueryParams, ArtifactsControllerFindAll401, ArtifactsControllerFindAll403 } from "../../models/documentArtifactsController/ArtifactsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { artifactsControllerFindAll } from "../../clients/document-artifactsService/artifactsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const artifactsControllerFindAllQueryKey = (documentId: ArtifactsControllerFindAllPathParams["documentId"], renditionId: ArtifactsControllerFindAllPathParams["renditionId"], params: ArtifactsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/documents/:documentId/renditions/:renditionId/artifacts',
  params: {
    documentId: documentId,
    renditionId: renditionId
  }
}, ...(params ? [params] : [])] as const;
export type ArtifactsControllerFindAllQueryKey = ReturnType<typeof artifactsControllerFindAllQueryKey>;
export function artifactsControllerFindAllQueryOptions(documentId: ArtifactsControllerFindAllPathParams["documentId"], renditionId: ArtifactsControllerFindAllPathParams["renditionId"], params?: ArtifactsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = artifactsControllerFindAllQueryKey(documentId, renditionId, params);
  return queryOptions<ArtifactsControllerFindAllQueryResponse, ResponseErrorConfig<ArtifactsControllerFindAll401 | ArtifactsControllerFindAll403>, ArtifactsControllerFindAllQueryResponse, typeof queryKey>({
    enabled: !!(documentId && renditionId),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return artifactsControllerFindAll(documentId, renditionId, params, config);
    }
  });
}

/**
 * @description Returns artifacts with JSON:API pagination, sorting, and filtering
 * @summary List all artifacts for a specific rendition
 * {@link /api/v1/documents/:documentId/renditions/:renditionId/artifacts}
 */
export function useArtifactsControllerFindAll<TData = ArtifactsControllerFindAllQueryResponse, TQueryData = ArtifactsControllerFindAllQueryResponse, TQueryKey extends QueryKey = ArtifactsControllerFindAllQueryKey>(documentId: ArtifactsControllerFindAllPathParams["documentId"], renditionId: ArtifactsControllerFindAllPathParams["renditionId"], params?: ArtifactsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<ArtifactsControllerFindAllQueryResponse, ResponseErrorConfig<ArtifactsControllerFindAll401 | ArtifactsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? artifactsControllerFindAllQueryKey(documentId, renditionId, params);
  const query = useQuery({
    ...artifactsControllerFindAllQueryOptions(documentId, renditionId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ArtifactsControllerFindAll401 | ArtifactsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}